import { createCachedSelector } from 're-reselect';
import { createSelector } from 'reselect';
import { AbridgedAsset } from 'store/assets/types';
import { SearchState } from 'store/search/types';
import { State } from 'store/types';

type SearchStateTree = Omit<Partial<State>, 'search'> & Pick<State, 'search'>;

const selectSearch = (state: SearchStateTree): SearchState => state.search;

export const selectSearchLoadKey = createSelector(
  selectSearch,
  (search: SearchState): string => search.loadKey,
);

export const selectSearchTotal = createSelector(
  selectSearch,
  ({ results }): number | null => results.total,
);

export const selectSearchAssetIds = createSelector(
  selectSearch,
  ({ results }): string[] => results.asset_ids,
);

export const selectSearchAsset = createCachedSelector(
  selectSearch,
  (_: SearchStateTree, id: string) => id,
  ({ results: { assets } }, id): AbridgedAsset => assets[id]!,
)((_: SearchStateTree, id: string) => id);

export const selectSearchOrganisation = createCachedSelector(
  selectSearch,
  (_: SearchStateTree, id: string) => id,
  ({ results: { organisations } }, id) => organisations[id]!,
)((_: SearchStateTree, id: string) => id);
